// extracted by mini-css-extract-plugin
module.exports = {"container":"CorpusEdition_container__2p8Gg","buttonContainer":"CorpusEdition_buttonContainer__Ek0dt","inputWrapper":"CorpusEdition_inputWrapper__3Ic4i"};